import { c as _c } from "react/compiler-runtime";
import { FormInputNumber, Hint, RadioGroup } from '@systemeio/ui';
import { MailingSplitTestWinnerTypeEnum, mailingSplitTestWinnerLocoKeys } from 'modules/newsletters/split-test/enum/mailing-split-test-winner-type-enum';
import { NewsletterSplitTestErrorType, SplitTestSettingsInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface';
import React, { useState } from 'react';
import TimeDelayPicker from 'shared/components/date-picker/time-delay-picker';
import { TimeType } from 'shared/components/date-picker/time-delay-picker/constants';
import { convertSeconds, convertSecondsToTimeValue, convertTimeValueToSeconds, convertToSeconds } from 'shared/components/date-picker/time-delay-picker/utils';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { FieldLabel } from 'shared/components/form/field-label';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
interface SplitTestSettingsProps {
  splitTestSettings: SplitTestSettingsInterface;
  onChange: (settings: SplitTestSettingsInterface) => void;
  errors: NewsletterSplitTestErrorType['settings'];
  disabled: boolean;
  isPreFetching: boolean;
}
export function SplitTestSettings(t0) {
  const $ = _c(100);
  const {
    splitTestSettings,
    onChange,
    errors,
    disabled,
    isPreFetching
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== splitTestSettings.durationInHours) {
    t1 = convertSecondsToTimeValue(convertToSeconds(splitTestSettings.durationInHours, TimeType.HOURS));
    $[0] = splitTestSettings.durationInHours;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedTime, setSelectedTime] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(MailingSplitTestWinnerTypeEnum);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t2.map(id => ({
      caption: t(mailingSplitTestWinnerLocoKeys[id]),
      id
    }));
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const options = t3;
  const isError = !errors?.winnerType || !errors?.emailRatio || !errors?.durationInHours;
  let t4;
  if ($[5] !== t) {
    t4 = t("dashboard.newsletter_editor.split_test.settings.title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <b className="text-text-primary text-start text-[17px]">{t4}</b>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isError && "border border-danger rounded-lg";
  let t7;
  if ($[9] !== t6) {
    t7 = twMerge(t6);
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [TimeType.DAYS, TimeType.HOURS];
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== errors?.durationInHours) {
    t9 = errors?.durationInHours?.join("\n");
    $[12] = errors?.durationInHours;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("dashboard.newsletter_editor.split_test.duration_description");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t) {
    t11 = t("dashboard.newsletter_editor.split_test.duration");
    $[16] = t;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <Hint label={t10}>{t11}</Hint>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== onChange || $[22] !== splitTestSettings) {
    t13 = (value, type) => {
      setSelectedTime(props => ({
        ...props,
        timeType: type,
        timeValue: value
      }));
      onChange({
        ...splitTestSettings,
        durationInHours: convertSeconds(convertTimeValueToSeconds(value, type), TimeType.HOURS)
      });
    };
    $[21] = onChange;
    $[22] = splitTestSettings;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== disabled || $[25] !== isPreFetching || $[26] !== selectedTime.timeType || $[27] !== selectedTime.timeValue || $[28] !== t12 || $[29] !== t13 || $[30] !== t9) {
    t14 = <TimeDelayPicker isPreFetching={isPreFetching} disabled={disabled} allowedOptions={t8} className="w-64" required={true} error={t9} label={t12} selectedTimeType={selectedTime.timeType} selectedTimeValue={selectedTime.timeValue} onChange={t13} />;
    $[24] = disabled;
    $[25] = isPreFetching;
    $[26] = selectedTime.timeType;
    $[27] = selectedTime.timeValue;
    $[28] = t12;
    $[29] = t13;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("dashboard.newsletter_editor.split_test.contacts_requirement");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("dashboard.newsletter_editor.split_test.email_ratio.title");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <FieldLabel required={true} label={<Hint label={t15}>{t16}</Hint>} />;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t) {
    t18 = t("dashboard.newsletter_editor.split_test.email_ratio.test");
    $[39] = t;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t18) {
    t19 = <b className="text-text-primary">{t18}</b>;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== onChange || $[44] !== splitTestSettings) {
    t20 = value_0 => onChange({
      ...splitTestSettings,
      emailRatio: value_0
    });
    $[43] = onChange;
    $[44] = splitTestSettings;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== errors?.emailRatio) {
    t21 = errors?.emailRatio?.join("\n");
    $[46] = errors?.emailRatio;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== disabled || $[49] !== isPreFetching || $[50] !== splitTestSettings.emailRatio || $[51] !== t20 || $[52] !== t21) {
    t22 = <FormInputNumber isPreFetching={isPreFetching} disabled={disabled} className="w-28" value={splitTestSettings.emailRatio} onChange={t20} max={100} addonAfter="%" error={t21} type="integer" />;
    $[48] = disabled;
    $[49] = isPreFetching;
    $[50] = splitTestSettings.emailRatio;
    $[51] = t20;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t19 || $[55] !== t22) {
    t23 = <div className="flex items-baseline gap-3">{t19}{t22}</div>;
    $[54] = t19;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t) {
    t24 = t("dashboard.newsletter_editor.split_test.email_ratio.winner");
    $[57] = t;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t24) {
    t25 = <b className="text-text-primary">{t24}</b>;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  const t26 = 100 - splitTestSettings.emailRatio;
  let t27;
  if ($[61] !== onChange || $[62] !== splitTestSettings) {
    t27 = value_1 => onChange({
      ...splitTestSettings,
      emailRatio: 100 - value_1
    });
    $[61] = onChange;
    $[62] = splitTestSettings;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== disabled || $[65] !== isPreFetching || $[66] !== t26 || $[67] !== t27) {
    t28 = <FormInputNumber isPreFetching={isPreFetching} disabled={disabled} className="w-28" value={t26} onChange={t27} max={100} addonAfter="%" type="integer" />;
    $[64] = disabled;
    $[65] = isPreFetching;
    $[66] = t26;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t25 || $[70] !== t28) {
    t29 = <div className="flex items-baseline gap-3">{t25}{t28}</div>;
    $[69] = t25;
    $[70] = t28;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== t23 || $[73] !== t29) {
    t30 = <div className="flex flex-wrap items-start gap-5">{t23}{t29}</div>;
    $[72] = t23;
    $[73] = t29;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== t17 || $[76] !== t30) {
    t31 = <div className="flex flex-col gap-1">{t17}{t30}</div>;
    $[75] = t17;
    $[76] = t30;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  const t32 = disabled || isPreFetching;
  let t33;
  if ($[78] !== errors?.winnerType) {
    t33 = errors?.winnerType?.join("\n");
    $[78] = errors?.winnerType;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  let t34;
  if ($[80] !== t) {
    t34 = t("dashboard.newsletter_editor.split_test.determinate.title");
    $[80] = t;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== onChange || $[83] !== splitTestSettings) {
    t35 = winnerType => onChange({
      ...splitTestSettings,
      winnerType
    });
    $[82] = onChange;
    $[83] = splitTestSettings;
    $[84] = t35;
  } else {
    t35 = $[84];
  }
  let t36;
  if ($[85] !== options || $[86] !== splitTestSettings.winnerType || $[87] !== t32 || $[88] !== t33 || $[89] !== t34 || $[90] !== t35) {
    t36 = <RadioGroup disabled={t32} required={true} error={t33} label={t34} options={options} selected={splitTestSettings.winnerType} onChange={t35} />;
    $[85] = options;
    $[86] = splitTestSettings.winnerType;
    $[87] = t32;
    $[88] = t33;
    $[89] = t34;
    $[90] = t35;
    $[91] = t36;
  } else {
    t36 = $[91];
  }
  let t37;
  if ($[92] !== t14 || $[93] !== t31 || $[94] !== t36) {
    t37 = <div className="flex flex-col gap-5">{t14}{t31}{t36}</div>;
    $[92] = t14;
    $[93] = t31;
    $[94] = t36;
    $[95] = t37;
  } else {
    t37 = $[95];
  }
  let t38;
  if ($[96] !== t37 || $[97] !== t5 || $[98] !== t7) {
    t38 = <DisclosureBox defaultOpen={true} title={t5} wrapperClassName={t7}>{t37}</DisclosureBox>;
    $[96] = t37;
    $[97] = t5;
    $[98] = t7;
    $[99] = t38;
  } else {
    t38 = $[99];
  }
  return t38;
}